/**
 * Vistas del rol Inmobiliaria (4) que se bloquean mientras la agencia no
 * complete "Mi Información". Antes vivía solo en `AdminSidebar`; ahora la
 * comparten el sidebar y el buscador de menús (Ctrl+K / ⌘K) para mostrar lo mismo.
 */
export const RUTAS_BLOQUEADAS_SIN_DATOS: readonly string[] = [
  '/admin/inmobiliarias/mis-propiedades',
  '/admin/inmobiliarias/mis-ventas',
  '/admin/inmobiliarias/mis-agentes',
];

export const ROL_INMOBILIARIA = 4;

export interface ContextoBloqueoInmobiliaria {
  isSuperAdmin: boolean;
  /** `profile.rol_id === 4`. */
  isInmobiliariaRole: boolean;
  /** `useInmobiliariaDataStatus().isDataComplete`. */
  isDataComplete: boolean;
}

/** ¿`href` sale bloqueado (con candado) para este usuario? */
export function esRutaBloqueadaInmobiliaria(href: string, ctx: ContextoBloqueoInmobiliaria): boolean {
  if (ctx.isSuperAdmin) return false; // Super Admin always has access
  if (!ctx.isInmobiliariaRole) return false;
  return !ctx.isDataComplete && RUTAS_BLOQUEADAS_SIN_DATOS.includes(href);
}
